import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Button } from "react-bootstrap";
import { format } from "date-fns";
import { es } from "date-fns/locale";

import { formatNumberWithCommas } from "../../utils";
import ModalContainer from "../../components/ModalContainer";
import TablePayments from "../../pages/varo/orders/orderPayments/tablePayments";
import { Formik } from "formik";
import { getOrderType } from "../../models/ReportOperatorSalary";

const TableOrderPayment = ({ payments, start, end }) => {
  const [openModalInfo, setOpenModalInfo] = useState(null);
  const [modalType, setModalType] = useState({ title: "", component: null });
  const tablePaymentsRef = useRef(null);

  const openModal = (payment, type) => {
    const orderId = payment.order_id || payment.orderVial_id;
    if (!orderId) {
      console.error("order_id no está definido:", payment);
      return;
    }

    // Obtener folio real de la orden normal o vial para mostrar
    const folio =
      payment.Order?.folio ??
      payment.OrderVial?.folio ??
      (orderId ? orderId.toString().padStart(5, "0") : "N/A");

    setOpenModalInfo({ orderId, type, tipoOrden: payment.tipo });

    if (type === "payments") {
      setModalType({
        title: `Pagos de la orden con folio: ${folio
          .toString()
          .padStart(5, "0")}`,
        component: (
          <>
            <h5 className="mt-10px text-start">
              <i className="fa-solid fa-sack-dollar"></i> Pagos a CONTADO
            </h5>
            <Formik initialValues={{ payments: [] }} onSubmit={() => {}}>
              <TablePayments
                ref={tablePaymentsRef}
                paymentTypeCode="CONTADO"
                valuesKey="payments"
                disabled={true}
                orderId={orderId}
                tipoOrden={
                  payment.tipo === "Varo Express" ? "ordenVial" : payment.tipo
                }
              />
            </Formik>

            <h5 className="mt-10px text-start">
              <i className="fa-solid fa-sack-dollar"></i> Pagos a CRÉDITO
            </h5>
            <Formik initialValues={{ payments: [] }} onSubmit={() => {}}>
              <TablePayments
                ref={tablePaymentsRef}
                paymentTypeCode="CREDITO"
                valuesKey="payments"
                disabled={true}
                orderId={orderId}
                tipoOrden={
                  payment.tipo === "Varo Express" ? "ordenVial" : payment.tipo
                }
              />
            </Formik>
          </>
        ),
      });
    }
  };

  const closeModal = () => {
    setOpenModalInfo(null);
    setModalType({ title: "", component: null });
  };

  return (
    <div className="table-responsive mb-3">
      <table className="table table-hover table-panel text-nowrap align-middle mb-0">
        <thead className="sticky-thead table-light text-center">
          <tr>
            {/* <th className="align-middle">id pago</th> */}
            <th className="align-middle">Folio orden</th>
            <th className="align-middle">Pago registrado por</th>
            {/* <th className="align-middle">Plataforma</th> */}
            <th className="align-middle">Tipo de Vehículo</th> 
            <th className="align-middle">Tipo de Servicio</th>
            <th className="align-middle">Fecha de Pago</th>
            <th className="align-middle">Tipo de Pago</th>
            <th className="align-middle">Monto</th>
            <th className="align-middle">Pagos</th>
          </tr>
        </thead>

        <tbody>
          {payments.map((payment) => {
            const orderId = payment.order_id || payment.orderVial_id;

            // Folio de orden
            const folio =
              payment.Order?.folio ??
              payment.OrderVial?.folio ??
              (orderId ? orderId.toString().padStart(5, "0") : "N/A");

            // Tipo de servicio
            let tipoServicio;
            if (payment.tipo === "Varo Express") {
              tipoServicio =
                payment.OrderVial?.typeService?.type_service_name ?? "N/A";
            } else {
              if (payment.Order?.typeService?.type_service_name) {
                tipoServicio = payment.Order.typeService.type_service_name;
              } else if (payment.Order) {
                tipoServicio = getOrderType(payment.Order);
              } else {
                tipoServicio = "N/A";
              }
            }
            const paymentType =
              payment?.PaymentMethod?.payment_method || "N/A";

            return (
              <tr className="text-center" key={payment.id}>
                {/* <td>{payment.id}</td> */}
                <td>
                  <Row className="mb-2">
                    <Col md="12">
                      <Link
                        to={
                          payment.tipo === "Varo Express"
                            ? `/orders-vial/editOrder/${orderId}`
                            : `/orders/edit/${orderId}`
                        }
                      >
                        {folio.toString().padStart(5, "0")}
                      </Link>
                    </Col>
                  </Row>
                </td>
                <td>
                  {payment.creator_payment
                    ? `${payment.creator_payment.name} ${payment.creator_payment.first_surname}`
                    : "N/A"}
                </td>

                {/* <td>{payment.tipo}</td> */}
                <td>
                  {payment.tipo === "Varo Express"
                    ? (payment.OrderVial?.vehicles?.map(v => v.VehicleModel?.VehicleType?.vehicle_type_name).join(", ") || "N/A")
                    : (payment.Order?.Vehicles?.map(v => v.VehicleModel?.VehicleType?.vehicle_type_name).join(", ") || "N/A")}
                </td>
                <td>{tipoServicio}</td>
                <td>
                  {(() => {
                    const [year, month, day] = payment.payment_date.split('-');
                    return `${day}-${month}-${year}`;
                  })()}
                </td>
                <td>{paymentType}</td>
                <td>${formatNumberWithCommas(payment.payment_amount)}</td>
                <td>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => openModal(payment, "payments")}
                  >
                    Ver pagos
                  </Button>
                  <ModalContainer
                    open={
                      openModalInfo?.orderId === orderId &&
                      openModalInfo?.type === "payments"
                    }
                    closeFn={closeModal}
                    title={modalType.title}
                    children={modalType.component}
                    size="xl"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableOrderPayment;
